module.exports = __webpack_public_path__ + "img/map.517d80d6.svg";